import React, { useEffect, useState } from 'react'
import avtar1 from '../../assets/images/user/avatar-1.jpg'
import { Link } from 'react-router-dom'
import { deleteData, getData, imgUrl, patchData } from '../Services/api'
import Swal from 'sweetalert2'
import { toast } from 'react-toastify'
import Pagination from '../Services/Pagination'
import { saveAs } from 'file-saver';
import axios from 'axios';

const List = () => {
const [limit, setLimit] = useState(10);

    const [users, setUsers] = useState([]);
    const [page, setPage] = useState(1);
    const [pages, setPages] = useState(1);
    const [total, setTotal] = useState(0);
    const [search, setSearch] = useState('');


    const downloadExcel = async () => {
    try {
        const res = await axios.get(`${imgUrl}/api/v1/complaints/export`, {
        responseType: 'arraybuffer', // important!
        headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}` // if auth required
        }
        });

        const blob = new Blob([res.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        saveAs(blob, 'complaints.xlsx');
    } catch (err) {
        console.error('Error downloading Excel:', err);
    }
    };



        // const downloadExcel = async () => {
        // try {
        //     const res = await getData('/complaints/export', { responseType: 'blob' });

        //     // res is already a Blob
        //     const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        //     saveAs(blob, 'complaints.xlsx');
        // } catch (err) {
        //     console.error('Error downloading Excel:', err);
        // }
        // };


    const fetchUsers = async (pageNumber = page, searchQuery = search) => {
        try {
            const res = await getData(`/complaints/admin-all?page=${pageNumber}&search=${searchQuery}`);
            
            if (res.success) {
                setUsers(res.data || []);
                console.log(res.pagination)
                setPage(res.pagination.page || 1);
                setPages(res.pagination.totalPages || 0);
                setTotal(res.pagination.total || 1);
                setLimit(res.pagination.limit || 10);
            }
        } catch (error) {
            console.log("error fetch users", error)
        }
    }

    useEffect(() => {
        fetchUsers();
    }, [page, search]);

    const handlePageChange = (pageNumber) => {
        if (pageNumber !== page) {
            fetchUsers(pageNumber);
        }
    };


      // 🔹 Complaint status update
const handleResolve = async (id) => {
  try {
    const res = await patchData(`/complaints/${id}/resolve`);
    if (res.success) {
        fetchUsers()
      toast.success ("Complaint resolved successfully!");
    }
  } catch (err) {
    console.error(err);
    alert("Error while resolving complaint");
  }
};



    return (
            <div className="pc-container">
                <div className="pc-content">
                    <div className="page-header">
                        <div className="page-block">
                            <div className="row align-items-center">
                                <div className="col-md-12">
                                    <ul className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/">Home</Link>
                                        </li>
                                        <li className="breadcrumb-item" aria-current="page">
                                            Complaint
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-md-12">
                                    <div className="page-header-title col-lg-6">
                                        <h2 className="mb-0">Complaint List</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card table-card">
                                <div className="card-body">
                                    <div className="d-sm-flex align-items-center p-4">
                                        <ul className="list-inline me-auto my-1">
                                            <li className="list-inline-item">
                                                <button className="btn btn-success mb-3" onClick={downloadExcel}>
                                                Export All Complaints
                                                </button>
                                                {/* <div className="form-search">
                                                    <i className="fas fa-search" />
                                                    <input
                                                        type="search"
                                                        className="form-control"
                                                        placeholder="Search user"
                                                        value={search}
                                                        onChange={(e) => {
                                                            setSearch(e.target.value);
                                                            setPage(1);
                                                        }}
                                                    />
                                                </div> */}
                                            </li>
                                        </ul>
                                        
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table table-hover" id="pc-dt-simple">
                                            <thead>
                                                <tr>
                                                    <th>S.No.</th>
                                                    <th>Type</th>
                                                    <th>Subject</th>
                                                    <th>User Name</th>
                                                    <th>Status</th>
                                                    <th className="text-center">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    users?.length > 0 ? (
                                                        users.map((user, index) => {
                                                            return (
                                                                <tr key={user.id}>
                                                                    <td>{index + 1 + (page - 1) * 10}</td>
                                                                    <td> {user.type}</td>
                                                                    <td>{user.subject}</td>
                                                                     <td>{user.user?.username}</td>
                                                                     <td>
                                                                        {user.status !== 'resolved' ? (
                                                                            <li className="list-inline-item">
                                                                                <button
                                                                                onClick={() => handleResolve(user.id)}
                                                                                className="btn btn-sm btn-danger"
                                                                                >
                                                                                Pending
                                                                                </button>
                                                                            </li>
                                                                            ) : (
                                                                            <li className="list-inline-item text-success fw-bold">
                                                                                Resolved
                                                                            </li>
                                                                            )}
                                                                     </td>
                                                                     <td className="text-center">
                                                                        <ul className="list-inline me-auto mb-0">
                                                                            <li
                                                                                className="list-inline-item align-bottom"
                                                                                data-bs-toggle="tooltip"
                                                                                title="View"
                                                                            >
                                                                                <Link
                                                                                    to={`/complaint/view-complaint/${user.id}`}
                                                                                    className="avtar avtar-xs btn-link-secondary btn-pc-default"
                                                                                >
                                                                                    <i className="fas fa-eye f-18" />
                                                                                </Link>
                                                                            </li>
                                                                        </ul>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })
                                                    ) : (
                                                        <tr>
                                                            <td className='text-center' colSpan={6}><strong>No Users Found.</strong></td>
                                                        </tr>
                                                    )
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center px-4 pb-3">
                                        <div className="text-muted">
                                        Showing {(page - 1) * 10 + 1} to {Math.min(page * 10, total)} of {total} entries
                                        </div>
                                        <Pagination
                                        page={page}
                                        pages={pages}
                                        onPageChange={(pageNumber) => fetchUsers(pageNumber, search)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    )
}

export default List